import { PageVisibilityMonitor } from './pageVisibilityMonitor';

const props = [];

export const PageVisibilityMonitorDirective = reactDirective => reactDirective(PageVisibilityMonitor, props);
    PageVisibilityMonitorDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('pageVisibilityMonitor', PageVisibilityMonitorDirective);
